import { SET_SEARCH_NOTIFY, CLEAR_SEARCH_NOTIFY } from "../actions";

export function setSearchNotify(payload = "") {
  return {
    type: SET_SEARCH_NOTIFY,
    payload
  };
}

export function clearSearchNotify(payload) {
  return {
    type: CLEAR_SEARCH_NOTIFY
  };
}



// WEBPACK FOOTER //
// ./src/store/actionCreators/searchNotify.js